import { Component } from '@angular/core';

// interface ChangelogEntry {
//   version: string;
//   date: string;
//   changes: string[];
//   knownIssues?: string[];
// }

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss'],
})
export class ChangelogComponent {
  // When we get around to building a blog feature I guess.
  filterByPlatform(platform: string) {
    const entries = document.querySelectorAll('.changelog-entry');
    entries.forEach((entry) => {
      const platforms = entry.getAttribute('data-platforms')?.split(',');
      if (platform && platforms?.includes(platform)) {
        entry.classList.remove('hidden');
      } else if (!platform) {
        entry.classList.remove('hidden');
      } else {
        entry.classList.add('hidden');
      }
    });
  }
}
